import React from "react";

import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import HeroImage from "../../../assets/zemen-service.jpg";

const Services = () => {
  React.useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 700,
      easing: "ease-in-out",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <Navbar />
      <section className="relative w-full h-[75vh] overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 w-full h-full bg-center bg-cover"
          style={{ backgroundImage: `url(${HeroImage})` }}
        ></div>

        {/* Optional overlay */}
        <div className="absolute inset-0 bg-black/0"></div>

        {/* Content */}
        <div className="relative z-10 flex items-center justify-center h-full w-full text-center px-6">
          <h2 className="text-4xl md:text-6xl font-bold text-white">
            Services
          </h2>
        </div>
      </section>
      <div class="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <div class="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
          <div>
            <p class="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
              Order Now
            </p>
          </div>
          <h2 class="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
            <span class="relative inline-block">
              <svg
                viewBox="0 0 52 24"
                fill="currentColor"
                class="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-blue-gray-100 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
              >
                <defs>
                  <pattern
                    id="34f481be-159a-4846-821d-9ca19fb6bcc5"
                    x="0"
                    y="0"
                    width=".135"
                    height=".30"
                  >
                    <circle cx="1" cy="1" r=".7"></circle>
                  </pattern>
                </defs>
                <rect
                  fill="url(#34f481be-159a-4846-821d-9ca19fb6bcc5)"
                  width="52"
                  height="24"
                ></rect>
              </svg>
              <span class="relative">Take</span>
            </span>
            Your Business Digital with Zemen Technology Solutions!
          </h2>
        </div>
        <div class="grid gap-8 row-gap-5 mb-8 md:row-gap-8 lg:grid-cols-4 sm:grid-cols-2 px-4">
          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">Web Development</h6>
              <p class="text-sm text-gray-900">
                We create modern, responsive, and secure websites that help
                businesses grow online.
              </p>
            </div>
          </div>
          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">Mobile Apps</h6>
              <p class="text-sm text-gray-900">
                Custom mobile applications built for Android and iOS to engage
                customers on the go.
              </p>
            </div>
          </div>
          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">UI/UX Design</h6>
              <p class="text-sm text-gray-900">
                User-focused designs that make your digital products simple,
                attractive, and easy to use.
              </p>
            </div>
          </div>
          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">Payment Integration</h6>
              <p class="text-sm text-gray-900">
                Secure local and international payment gateways for smooth and
                reliable transactions.
              </p>
            </div>
          </div>

          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">ERP Systems</h6>
              <p class="text-sm text-gray-900">
                Scalable ERP solutions that streamline operations and improve
                business efficiency.
              </p>
            </div>
          </div>
          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">Tech Consultancy</h6>
              <p class="text-sm text-gray-900">
                Advising organizations on digital strategy, modernization, and
                implementation of scalable systems.
              </p>
            </div>
          </div>
          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">Capacity Building</h6>
              <p class="text-sm text-gray-900">
                Workshops, mentorship, and training programs on emerging tech
                and tools.
              </p>
            </div>
          </div>
          <div class="duration-300 transform bg-white border-l-4 border-deep-purple-accent-400 hover:-translate-y-2">
            <div class="h-full p-5 border border-l-0 rounded-r shadow-sm">
              <h6 class="mb-2 font-semibold leading-5">Cloud Services</h6>
              <p class="text-sm text-gray-900">
                Reliable cloud-based solutions for storage, hosting, and
                scalable IT infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div>
      <section class="bg-white dark:bg-gray-900">
        <div class="container px-6 py-8 mx-auto">
          <div class="sm:flex sm:items-center sm:justify-between">
            <div>
              <h2 class="text-2xl font-bold text-gray-800 lg:text-3xl dark:text-gray-100">
                Pricing Plans
              </h2>
            </div>

            <div class="overflow-hidden p-0.5 mt-6 border rounded-lg dark:border-gray-700">
              <div class="sm:-mx-0.5 flex">
                <button class=" focus:outline-none px-3 w-1/2 sm:w-auto py-1 sm:mx-0.5 text-white bg-blue-500 rounded-lg">
                  Monthly
                </button>
                <button class=" focus:outline-none px-3 w-1/2 sm:w-auto py-1 sm:mx-0.5 text-gray-800 dark:text-gray-200 dark:hover:bg-gray-800 bg-transparent rounded-lg hover:bg-gray-200">
                  Yearly
                </button>
              </div>
            </div>
          </div>

          <div class="grid gap-6 mt-16 -mx-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 px-4">
            <div class="px-6 py-4 transition-colors duration-300 transform rounded-lg hover:bg-gray-200 dark:hover:bg-gray-800">
              <p class="text-lg font-medium text-gray-800 dark:text-gray-100">
                Standard
              </p>

              <h4 class="mt-2 text-3xl font-semibold text-gray-800 dark:text-gray-100">
                -
                <span class="text-base font-normal text-gray-600 dark:text-gray-400">
                  / Year
                </span>
              </h4>

              <p class="mt-4 text-gray-500 dark:text-gray-300">
                For most businesses that want to optimaize web queries.
              </p>

              <div class="mt-8 space-y-8">
                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Up to 10 pages
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Own analytics platform
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Free 1 Year Domain and Hosting
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Free Training
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Social media Integration
                  </span>
                </div>
              </div>

              <button class="w-full px-4 py-2 mt-10 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">
                Choose plan
              </button>
            </div>

            <div class="px-6 py-4 transition-colors duration-300 transform rounded-lg hover:bg-gray-200 dark:hover:bg-gray-800">
              <p class="text-lg font-medium text-gray-800 dark:text-gray-100">
                Popular
              </p>

              <h4 class="mt-2 text-3xl font-semibold text-gray-800 dark:text-gray-100">
                -
                <span class="text-base font-normal text-gray-600 dark:text-gray-400">
                  / Year
                </span>
              </h4>

              <p class="mt-4 text-gray-500 dark:text-gray-300">
                For most businesses that want to optimaize web queries.
              </p>

              <div class="mt-8 space-y-8">
                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Up to 25 pages
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Content Management Dashboard
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Chat support
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Free 1 Year Domain and Hosting
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Unlimited users
                  </span>
                </div>
              </div>

              <button class="w-full px-4 py-2 mt-10 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">
                Choose plan
              </button>
            </div>

            <div class="px-6 py-4 transition-colors duration-300 transform bg-gray-700 rounded-lg dark:bg-gray-800">
              <p class="text-lg font-medium text-gray-100"> Enterprise</p>

              <h4 class="mt-2 text-3xl font-semibold text-gray-100">
                -<span class="text-base font-normal text-gray-400">/ Year</span>
              </h4>

              <p class="mt-4 text-gray-300">
                For most businesses that want to optimaize web queries.
              </p>

              <div class="mt-8 space-y-8">
                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-300">Up to 40 pages</span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-300">2 Year Revision</span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-300">Chat support</span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-300">
                    Add Payment Integration
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-300">
                    Free 1 Year Support and Warranty
                  </span>
                </div>
              </div>

              <button class="w-full px-4 py-2 mt-10 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">
                Choose plan
              </button>
            </div>

            <div class="px-6 py-4 transition-colors duration-300 transform rounded-lg hover:bg-gray-200 dark:hover:bg-gray-800">
              <p class="text-lg font-medium text-gray-800 dark:text-gray-100">
                Mobile Apps
              </p>

              <h4 class="mt-2 text-3xl font-semibold text-gray-800 dark:text-gray-100">
                -
                <span class="text-base font-normal text-gray-600 dark:text-gray-400">
                  / Year
                </span>
              </h4>

              <p class="mt-4 text-gray-500 dark:text-gray-300">
                For most businesses that want to optimaize mobile apps.
              </p>

              <div class="mt-8 space-y-8">
                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Cross-Device Compatibility
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Push Notifications
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Offline Functionality
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Data Privacy & Compliance
                  </span>
                </div>

                <div class="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 text-blue-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span class="mx-4 text-gray-700 dark:text-gray-300">
                    Payment Gateways
                  </span>
                </div>
              </div>

              <button class="w-full px-4 py-2 mt-10 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">
                Choose plan
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default Services;
